<template lang="pug">
  // Root element of PhotoSwipe. Must have class pswp.
  .pswp(tabindex="-1" role="dialog" aria-hidden="true")
    //
      Background of PhotoSwipe.
      It's a separate element as animating opacity is faster than rgba().
    .pswp__bg
    // Slides wrapper with overflow:hidden.
    .pswp__scroll-wrap
      //
        Container that holds slides.
        PhotoSwipe keeps only 3 of them in the DOM to save memory.
        Don't modify these 3 pswp__item elements, data is added later on.
      .pswp__container
        .pswp__item
        .pswp__item
        .pswp__item
      // Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed.
      .pswp__ui.pswp__ui--hidden
        .pswp__top-bar
          // Controls are self-explanatory. Order can be changed.
          .pswp__counter
          button.pswp__button.pswp__button--close(title="Schließen (Esc)")
          button.pswp__button.pswp__button--share(title="Teilen")
          button.pswp__button.pswp__button--fs(title="Vollbild")
          button.pswp__button.pswp__button--zoom(title="Zoom in/out")
          // Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR
          // element will get class pswp__preloader--active when preloader is running
          .pswp__preloader
            .pswp__preloader__icn
              .pswp__preloader__cut
                .pswp__preloader__donut
        .pswp__share-modal.pswp__share-modal--hidden.pswp__single-tap
          .pswp__share-tooltip
        button.pswp__button.pswp__button--arrow--left(title="Vorheriges Bild (Pfleil nach links)")
        button.pswp__button.pswp__button--arrow--right(title="Nächstes Bild (Pfeil nach rechts)")
        .pswp__previews(data-previews)
        .pswp__caption
          .pswp__caption__center
</template>

<script>
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeDefaultUI from 'photoswipe/dist/photoswipe-ui-default';

import { photoswipeVideos } from './videos';
import { photoswipePreviews } from './previews';

export default {
    methods: {
        open(
            event,
            index,
            items,
            options = {
                // captionEl: false,
                fullscreenEl: false,
                history: false,
                shareEl: false,
                tapToClose: true,
                closeOnScroll: false,
                closeOnVerticalDrag: false,
                preload: [2, 3]
            }
        ) {
            const opts = Object.assign(
                {
                    index: index,
                    getThumbBoundsFn(index) {
                        const list = event.target.closest('.preview-img-list');
                        if (list && list.querySelectorAll('.preview-img-item')[index]) {
                            const thumbnail = list.querySelectorAll('.preview-img-item')[index];
                            const pageYScroll =
                                window.pageYOffset ||
                                document.documentElement.scrollTop ||
                                document.body.scrollTop ||
                                0;
                            const rect = thumbnail.getBoundingClientRect();
                            return {
                                x: rect.left,
                                y: rect.top + pageYScroll,
                                w: rect.width
                            };
                        }
                    }
                },
                options
            );

            this.photoswipe = new PhotoSwipe(this.$el, PhotoSwipeDefaultUI, items, opts);
            photoswipeVideos(this.photoswipe);
            photoswipePreviews(this.photoswipe);
            this.photoswipe.init();
        },

        close() {
            this.photoswipe.close();
        }
    }
};
</script>

<style lang="sass">
.pswp__bg
  background: rgba(0,0,0,0.9)
  backdrop-filter: blur(10px)

.pswp__button--arrow--left:before, .pswp__button--arrow--right:before
  background-color: transparent

.pswp--animate_opacity
  will-change: initial
  transition: none

.pswp__with-previews .pswp__caption
  top: 3rem
  bottom: auto

.pswp-video-container
  width: 100%
  padding: 60px 1rem
  height: 100vh
  display: flex
  justify-content: center
  align-items: center
  .pswp-video-size-limiter,
  .pswp-video-bypass-click-prevention
    max-width: 100%
  .pswp-video-size-limiter
    background-color: rgba(black, 0.3)
    position: relative
  .video-js.vjs-city-offer
    overflow: hidden
    background: black
    // position: absolute
    // top: 0
    // left: 0
    // width: 100%
    // height: 100%
    transition: opacity 0.3s
    // padding-top: 0
    video
      transition: opacity 0.3s
    .vjs-control-bar
      opacity: 1 !important
    .vjs-play-control
      display: none
    .vjs-progress-control
      // opacity: 0
      // pointer-events: none
    .vjs-big-play-button
      border: 1px solid black
      color: black

    &:hover, &:focus
      .vjs-big-play-button
        border: 1px solid black
        color: black

    .vjs-remaining-time
      display: none

    .vjs-loading-spinner
      border: 3px solid rgba(0,0,0, 0.6)
      &:before, &:after
        border-color: rgba(140,140,140,.2)
        border-top-color: rgba(255,255,255,.9)


.pswp__with-previews
  .pswp
    // &__caption
    //   bottom: 3em
    &__previews
      position: absolute
      bottom: 0
      left: 0
      width: 100%
      display: flex
      flex-flow: row
      justify-content: center
      background-color: rgba(black, 0.3)
      overflow: auto
      // Hide scrollbar in Quantum (Firefox)
      scrollbar-width: none
      // Hide scrollbar in Blink (Chrome)
      &::-webkit-scrollbar
        display: none
      figure.video-thumbnail
        position: relative
        height: calc(3rem - 8px)
        width: 2rem
        margin: 4px 2px
        border: 1px solid rgb(148 148 148 / 30%)
        background-color: rgba(black, 0.3)
        border-radius: 3px
        opacity: 0.3
        transition: opacity 0.3s
        cursor: pointer
        &:hover
          opacity: 0.8
        &.is-active
          opacity: 1
          cursor: default
          background-color: rgb(148 148 148 / 30%)
        &:before
          content: ''
          position: absolute
          left: calc(50% - 0.35rem)
          top: calc(50% - 0.6rem)
          box-sizing: border-box
          width: 1rem
          height: 1.2rem
          border-width: calc(1.2rem / 2) 0px calc(1.2rem / 2) calc(0.9rem)
          border-color: transparent transparent transparent #FFF
      img
        max-height: calc(3rem - 8px)
        margin: 4px 2px
        object-fit: cover
        opacity: 0.3
        transition: opacity 0.3s
        cursor: pointer
        border-radius: 3px
        &:hover
          opacity: 0.8
        &.is-active
          opacity: 1
          cursor: default
</style>
